module.exports = __webpack_public_path__ + "img/medical.05938fc7.png";